/**
 * 报警计划监控车辆组件
 * 创建时间：2017-05-11
 * 创建人：zhanlz
 * 修改时间：2017-04-18
 */
<template>
	<div>
        <div v-if="$parent.mode!=2">
			<div class="row">
				<div class="col-sm-12 ">
					<div class="module_title"> <span class="focus_color">请指定监控车辆</span> </div>
				</div>
			</div>
			<!--指定车辆选择-->
			<div class="row">
				<form role="form" class="form-inline">
					<div class="col-sm-12">
						<div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmMonitorInfo.alarmMonitorMode" true-value="1">本企业及下属企业所有车辆</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmMonitorInfo.alarmMonitorMode" true-value="2">仅本企业所有车辆</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmMonitorInfo.alarmMonitorMode" true-value="3">仅限选定的车辆分支</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmMonitorInfo.alarmMonitorMode" true-value="4">仅限选定的车辆关注面板</radio>
	    					</label>
	                    </div>
						<div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmMonitorInfo.alarmMonitorMode" true-value="5">仅限选定的车辆</radio>
	    					</label>
	                    </div>
					</div>
				</form>
			</div>
			<div class="row grey_box mb10px" v-show="alarmMonitorInfo.alarmMonitorMode=='5'" v-loading="alarmMonitorInfo.vehicleInfo.loadingstatus" element-loading-text="加载中">
				<form role="form" class="form-horizontal pt10px">
					<div class="form-group">
						<label class="col-sm-1 control-label">车辆ID</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model.trim="alarmMonitorInfo.vehicleInfo.queryParam.vehicleId">
						</div>
						<label class="col-sm-1 control-label">服务卡号</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model.trim="alarmMonitorInfo.vehicleInfo.queryParam.vehicleAccount">
						</div>
						<label class="col-sm-1 control-label">车牌号</label>
						<div class="col-sm-2">
							<vplate-input type="text" class="form-control" v-model.trim="alarmMonitorInfo.vehicleInfo.queryParam.plateNumber"/>
						</div>
						<label class="col-sm-1 control-label">所属分支</label>
						<div class="col-sm-2">
							<input type="text" class="form-control menuInputBrand" id="group_listd" v-model="queryGroup" autocomplete="off" disableautocomplete @focus="showMenu">
							<div id="menuContent" class="menuContent" style="display:none; position: absolute;">
								<ul id="orgTreeBrand" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
							</div>
				        </div>
					</div>
					<p class="help-block focus_color text-right" v-if="alarmMonitorInfo.vehicleInfo.areaTipStatis">未找到对应的车辆信息，请更换其它查询条件再试。</p>
					<div class="form-group">
						<div class="col-sm-12 text-right">				
							<button type="button" v-if="permission.indexOf('monitorVehicle_setVehicleSelect') == -1" class="btn btn-primary " @click="searchMonitorListVehicle">查询</button>
						</div>
					</div>
				</form>
				<div v-if="alarmMonitorInfo.hiddenAppoint">
					<form role="form" class="form-horizontal pt10px">
						<div class="col-sm-10">
							<div class="form-group">
		                		<button type="button" class="btn btn-primary" @click="selectAllVehicle">{{alarmMonitorInfo.vehicleInfo.selAllFlg?'全取消':'全选'}}</button>
		                		<button type="button" v-if="permission.indexOf('monitorVehicle_setVehicleAdd') == -1" class="btn btn-primary" @click="saveMonitorListVehicle()">添加到监控清单</button>
		                	</div>
						</div>
						<div class="col-sm-2 text-right">
							<div class="form-group">
		                		<button type="button" class="btn btn-primary" @click="hideMonitorResult">隐藏查询结果</button>
		                	</div>
						</div>
					</form>
					
					<table class="table mt20px table-striped table-bordered">
						<thead>
							<tr>
								<th></th>
								<th>所属分支</th>
								<th>车辆ID</th>
								<th>服务卡号</th>
								<th>车牌号</th>
								<th>车型车系</th>
								<th>车辆登记日期</th>
								<th>车主</th>
								<th>联系方式</th>
								<th>车辆当前位置</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(fileInfo,index) in alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicle" v-bind:key="index">
								<td class="text-center">
									<input style="margin-top:0px;" type="checkbox" :name="checkbox_vehicle" @change="changeVehicleSel(fileInfo.vehicleId,$event.currentTarget)">
								</td>
								<td>{{fileInfo.groupName}}</td>
								<td>{{fileInfo.vehicleId}}</td>
								<td>{{fileInfo.vehicleAccount}}</td>
								<td>{{fileInfo.plateNumber}}</td>
								<td>{{fileInfo.vehicleTypeSerie}}</td>
								<td>{{fileInfo.startSaleTime}}</td>
								<td>{{fileInfo.ownerName}}</td>
								<td>{{fileInfo.phone}}</td>
								<td>{{fileInfo.address}}</td>
								<td class="text-center">
									<a v-if="permission.indexOf('monitorVehicle_setVehicleSelectDetail') == -1" class="text-center" @click="gotoCarDetail(fileInfo.plateNumber,fileInfo.vehicleId)">详情</a>
									<a v-if="permission.indexOf('monitorVehicle_setVehicleSelectAdd') == -1" class="text-center" @click="saveMonitorListVehicleSimple(fileInfo.vehicleId)">添加</a>
								</td>
							</tr>
						</tbody>
					</table>
					<!--分页组件开始-->
					<pagination  v-if="alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicle.length>0" :pageInfo="alarmMonitorInfo.vehicleInfo.vehiclePageInfo" v-on:getData="getVehiclePageNo"></pagination>
					<!--分页组件结束-->
				</div>
			</div>
			<div class="row grey_box mb10px" v-show="alarmMonitorInfo.alarmMonitorMode=='4'" v-loading="alarmMonitorInfo.vehiclePanelInfo.loadingstatus" element-loading-text="加载中">
				<form role="form" class="form-horizontal pt10px">
					<label class="col-sm-2 control-label">请选择车辆关注面板的名称</label>
					<div class="col-sm-2">
						<input type="text" class="form-control menuInputBrand" id="groupName_lists" @focus="showMenuSelectName" readonly value="单击选择" style="background: #47ac89;color: #fff;border-width: 0;border-radius: 4px;">
						<div id="menuContentSelectName" class="menuContent" style="display:none; position: absolute;">
							<ul id="orgTreeBrandSelectName" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
						</div>
			        </div>
				</form>
			</div>	
			<div class="row grey_box mb10px" v-show="alarmMonitorInfo.alarmMonitorMode=='3'">
				<form role="form" class="form-horizontal pt10px">
					<label class="col-sm-2 control-label">请选择车辆分支名称</label>
					<div class="col-sm-2">
						<input type="text" class="form-control menuInputBrand" id="group_lists" @focus="showMenuSelect" readonly value="单击选择" style="background: #47ac89;color: #fff;border-width: 0;border-radius: 4px;">
						<div id="menuContentSelect" class="menuContent" style="display:none; position: absolute;">
							<ul id="orgTreeBrandSelect" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
						</div>
			        </div>
				</form>
			</div>	
	    </div>
		
		<div class="row mb10px" v-show="alarmMonitorInfo.alarmMonitorMode=='5'||$parent.mode=='2'" v-loading="alarmMonitorInfo.monitorResultInfo.loadingstatus" element-loading-text="加载中">
			<h3 class="col-sm-12">监控车辆列表:(已监控台车辆)</h3>
			<form role="form" class="form-horizontal pt10px" v-if="$parent.mode!=2">
				<div class="col-sm-12">
					<div class="form-group">
                		<button type="button" class="btn btn-primary" @click="selectAllMonitorList">{{alarmMonitorInfo.monitorResultInfo.selAllFlg?'全取消':'全选'}}</button>
                		<button type="button" v-if="permission.indexOf('monitorVehicle_remove') == -1" class="btn btn-primary" @click="removeMonitorList()">移出</button>
                	</div>
				</div>
			</form>
			<table class="table mt20px table-striped table-bordered">
				<thead>
					<tr>
						<th v-if="$parent.mode!=2"></th>
						<th v-if="$parent.mode!=2"></th>
						<th>所属分支</th>
						<th>车辆ID</th>
						<th>服务卡号</th>
						<th>车牌号</th>
						<th>车型车系</th>
						<th>车辆登记日期</th>
						<th>车主</th>
						<th>联系方式</th>
						<th>车辆当前位置</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(fileInfo,index) in alarmMonitorInfo.monitorResultInfo.alarmMonitorList" v-bind:key="index">
						<td class="text-center" v-if="$parent.mode!=2">
							<input style="margin-top:0px;" type="checkbox" :name="checkbox_result" @change="changeResultSel(fileInfo.vehicleId,$event.currentTarget)">
						</td>
						<td class="text-center" v-if="$parent.mode!=2">
							<a v-if="permission.indexOf('monitorVehicle_delete') == -1" class="text-center" @click="removeMonitorListSimple(fileInfo.vehicleId)">移除</a>
						</td>
						<td>{{fileInfo.groupName}}</td>
						<td>{{fileInfo.vehicleId}}</td>
						<td>{{fileInfo.vehicleAccount}}</td>
						<td>{{fileInfo.plateNumber}}</td>
						<td>{{fileInfo.vehicleTypeSerie}}</td>
						<td>{{fileInfo.startSaleTime}}</td>
						<td>{{fileInfo.ownerName}}</td>
						<td>{{fileInfo.phone}}</td>
						<td>{{fileInfo.address}}</td>
						<td class="text-center">
							<a v-if="permission.indexOf('monitorVehicle_detail') == -1" class="text-center" @click="gotoCarDetail(fileInfo.plateNumber,fileInfo.vehicleId)">详情</a>
						</td>
					</tr>
				</tbody>
			</table>
			<!--分页组件开始-->
			<pagination  v-if="alarmMonitorInfo.monitorResultInfo.alarmMonitorList.length>0" :pageInfo="alarmMonitorInfo.monitorResultInfo.resultPageInfo" v-on:getData="getResultPageNo"></pagination>
			<!--分页组件结束-->
		</div>
		
    </div>
</template>

<script>
import Radio from 'components/common/Radio' 
import Pagination from 'components/common/Pagination'
import { OPERATE_EXCEPTION,SELECT_VEHICLE,OPERATE_SUCCESS} from 'static/message'
import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
import 'assets/plugins/ztree/js/jquery.ztree.core.js'
import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
import { queryTree } from 'util/util'

export default {
    name: 'AlarmPlanMonitor',
    components: {
    	Radio,
    	Pagination,
    },
    props: {
    	typeid: {
			type: String,
			dafault: ""
		}
    },
    data() {
        return {
        	permission:this.$store.state.permission.permission["alarmPlanHome"]?this.$store.state.permission.permission["alarmPlanHome"]:[],
        	checkbox_result:"checkbox_result" + this.$parent.mode,
        	checkbox_vehicle:"checkbox_vehicle" + this.$parent.mode,
        	//监控车辆
        	queryGroup:'',											//选中的groupid
			treeObj:[],
			alarmMonitorInfo: {
				//指定车辆查询参数
				vehicleInfo:{	
					loadingstatus:false,
					alarmBranchList:[],			    		//所属分支列表
					vehiclePageInfo:{},       				//指定车辆分页所需信息
					alarmMonitorListVehicle: [],  			//指定车辆查询列表
					alarmMonitorListVehicleSel: [], 		//选择的列表
					alarmMonitorListVehicleCancel: [], 		//取消的列表
					areaTipStatis:false,          			//提示信息显示状态
					pageNo: 1,
					selAllFlg:false,				    		//全选标志
					queryParam:{
						almType:this.typeid,											//报警类型
						customerId:this.$store.state.user.groupid,						//组织机构ID
						groupId:'',														//车辆分支ID
						plateNumber:'',	    											//选择车牌号
						vehicleAccount:'',												//选择服务卡号
						vehicleId:'',													//选择车辆ID
						page_index: 1
					},
					storeParam:{
						BranchValue:'',
						plateNumber:'',	    											//选择车牌号
						vehicleAccount:'',												//选择服务卡号
						vehicleId:''													//选择车辆ID
					}
				},
				//车辆关注面板信息
				vehiclePanelInfo:{		
					vehiclePanelList: [],           //选择车辆关注面板列表
					vehiclePanelSelList:[],			//选择的面板列表
					queryParam:{
						almType:this.typeid,
						panelId:'',					//设置默认车辆关注面板
						page_index: 1
					}
				},
				//车辆分支信息
				vehicleBranchInfo:{		
					vehicleBranchSelList:[],			//选择的分支列表
					queryParam:{
						almType:this.typeid,
						groupId:'',
						page_index: 1
					}
				},
				monitorResultInfo:{
					loadingstatus:false,
					alarmMonitorList: [],         		//当前监控列表
					alarmMonitorListSel: [], 			//选择的列表
					alarmMonitorListCancel: [],			//取消的列表
					resultPageInfo:{},               	//监控车辆分页所需信息
					pageNo: 1,
					selAllFlg:false,				     //全选标志
					queryParam:{
						type:this.$parent.mode,
						typeValue:this.$parent.mode=='0'?this.typeid:this.$parent.planid,
						page_index: 1
					}
				},
				alarmMonitorMode: '1',        			//监控时段模式
		        hiddenAppoint:true           			//指定车辆展示
			},
			//z-tree相关
				setting:{
					data: {
		                simpleData: {
		                    enable: true,
							idKey: "id",
						   pIdKey: "pId"
		                }
		           },
		           view: {
				        dblClickExpand: false,
				        selectedMulti: false,
				        autoCancelSelected: true
				    },
				    callback: {
				        onClick: this.onClick
				    }
				},
				setting2:{
					data: {
		                simpleData: {
		                    enable: false,
		                }
		           },
		           view: {
				        dblClickExpand: false,
				        selectedMulti: false,
				        autoCancelSelected: true
				    },
				    callback: {
				        onClick: this.onClick
				    }
				},
				settingSelect:{
					data: {
		                simpleData: {
		                    enable: true,
							idKey: "id",
						   pIdKey: "pId"
		                }
		           },
		           	check: {
		           		enable: true,
		           		chkboxType : { "Y" : "", "N" : "" }
		           	},
		           view: {
				        dblClickExpand: false,
				        selectedMulti: false,
				        autoCancelSelected: true
				    },
				    callback: {
				        onCheck: this.onClickSelect
				    }
				},
				settingName: {
					data: {
						simpleData: {
							enable: true,
							pIdKey: "parentId"
						}
					},
					check: {
		           		enable: true,
		           		chkboxType : { "Y" : "", "N" : "" }
		           	},
					view: {
						dblClickExpand: false,
						selectedMulti: true,
						autoCancelSelected: true
					},
					callback: {
						onCheck: this.onClickSelectName
					}
				},
        };
    },
    created(){
    	this.$emit('input', this.alarmMonitorInfo)
    },
    mounted(){
    	
    	if (this.$parent.mode!=2){
	    	this.$http.get(process.env.API_ROOT + '/monitor/tree/groups/', {params: {showTreeType:0}})
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						this.alarmMonitorInfo.vehicleInfo.alarmBranchList = res;
						this.alarmMonitorInfo.vehicleInfo.alarmBranchList.map(item => {
							item.open = true;
							return item;
						})
						this.treeInit()
						this.treeInitSelect()
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
				}	
			)
				
			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/panels')
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelList = res;
						this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelList.map(item=>{
							item.parentId=null;
							item.name=item.tagpanelName;
						})
						this.treeInitSelectName();
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
				}	
			)
		}
		
		//新建的时候
		if (this.$parent.mode=='0'){
			this.clearResultList();
		}
		//编辑的时候
		if (this.$parent.mode=='1' || this.$parent.mode=='2'){
			this.initResultList();
		}
   },
    methods: {
    	//显示、隐藏下拉树
			showMenu(){
				$("#menuContent").slideDown("fast");
				$("body").bind("mousedown", this.onBodyDown);
			},
			showMenuSelect(){
				$("#menuContentSelect").slideDown("fast");
				$("body").bind("mousedown", this.onBodyDowns);
			},
			showMenuSelectName(){
				$("#menuContentSelectName").slideDown("fast");
				$("body").bind("mousedown", this.onBodyDownsName);
			},
			onBodyDown(event){
				var self = this;
				if (!(event.target.id == "group_listd" || event.target.id == "menuContent" || $(event.target).parents("#menuContent").length>0)) {
					this.hideMenu();
				}
			},
			onBodyDowns(event){
				var self = this;
				if (!(event.target.id == "group_lists" || event.target.id == "menuContentSelect" || $(event.target).parents("#menuContentSelect").length>0)) {
					this.hideMenus();
				}
			},
			onBodyDownsName(event){
				var self = this;
				if (!(event.target.id == "groupName_lists" || event.target.id == "menuContentSelectName" || $(event.target).parents("#menuContentSelectName").length>0)) {
					this.hideMenusName();
				}
			},
			hideMenu() {
				$("#menuContent").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDown);
			},
			hideMenus() {
				$("#menuContentSelect").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDowns);
			},
			hideMenusName() {
				$("#menuContentSelectName").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDownsName);
			},
			//z-tree 相关
			treeInit(){//初始化z-tree树
				$.fn.zTree.init($("#orgTreeBrand"), this.setting, this.alarmMonitorInfo.vehicleInfo.alarmBranchList);
				this.$nextTick(() => { 
					this.treeObj = $.fn.zTree.getZTreeObj("orgTreeBrand").getNodes(); 
					this.queryGroup = this.treeObj[0].name
				})
			},
			treeInitSelect(){//初始化z-tree树
				$.fn.zTree.init($("#orgTreeBrandSelect"), this.settingSelect, this.alarmMonitorInfo.vehicleInfo.alarmBranchList);
			},
			treeInitSelectName(){//初始化z-tree树
				$.fn.zTree.init($("#orgTreeBrandSelectName"), this.settingName, this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelList);
			},
			onClick(e,treeId,treeNode){//点击树节点
				this.alarmMonitorInfo.vehicleInfo.queryParam.groupId = treeNode.id;
				this.queryGroup = treeNode.name;
			},
			onClickSelect(event,treeId,treeNode){//点击树节点
				this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList=[];
				this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList = this.getCheckRootNodes();
//				let that = this;
//				tmp2.forEach( item => {
//					that.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList.push(item);	
//				})
				
//				if (treeNode.checked){
//					this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList.push(treeNode.id);
//				}else{
//					let index = this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList.findIndex(function(value, index, arr) {
//					   return value == treeNode.id;
//					});
//					if (index != -1){
//						this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList.splice(index,1);
//					}
//				}
			},
			onClickSelectName(event,treeId,treeNode){//点击树节点
				if (treeNode.checked){
					this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelSelList.push(treeNode.id);
				}else{
					let index = this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelSelList.findIndex(function(value, index, arr) {
					   return value == treeNode.id;
					});
					if (index != -1){
						this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelSelList.splice(index,1);
					}
				}
			},
			getCheckRootNodes(){
				let queue = [];
				let result = [];
				let treeObj = $.fn.zTree.getZTreeObj("orgTreeBrandSelect");
				let tree = treeObj.getNodes();
				queue.push(...tree);
				while(queue.length != 0){
					let node = queue.shift();
					let checkState = node.getCheckStatus();
					// 若全勾选，则加到result
					if(checkState.checked && !checkState.half){
						result.push({
							groupId: node.id,
							noFilterStatus: "1"
						})
					} else if (checkState.checked && checkState.half){
						// 否则，若半勾选，则加到result并把childNode加到队列中
						result.push({
							groupId: node.id,
							noFilterStatus: "0"
						})
						if(node.children){
							queue.push(...node.children);
						}
					} else if (!checkState.checked){
						// 若未勾选，则把子节点加到队列中
						if(node.children){
							queue.push(...node.children);
						}
					}
				}
				return result;
			},
			
    		//查询指定车辆信息
    	searchMonitorListVehicle(){
    		this.alarmMonitorInfo.hiddenAppoint = true;
    		this.alarmMonitorInfo.vehicleInfo.queryParam.page_index = 1;
    		this.getMonitorListVehicle();
    	},
    	//查询指定车辆信息
		getMonitorListVehicle() { 
			if(this.queryGroup == ""){
				this.alarmMonitorInfo.vehicleInfo.queryParam.groupId = "";
			}
			this.alarmMonitorInfo.vehicleInfo.loadingstatus = true;
			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/' + this.typeid + '/sel/vehicles',{params: this.alarmMonitorInfo.vehicleInfo.queryParam})
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						if (res.list.length>0){
							this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicle = res.list;
							const {pageNum,pages,total,isFirstPage,isLastPage} = res;
							this.alarmMonitorInfo.vehicleInfo.vehiclePageInfo = {								
								pageNum:pageNum,
								pages:pages,		
								total: total,
								isFirstPage:isFirstPage,
								isLastPage:isLastPage
							}
							this.$nextTick(function(){
				                this.setVehicleCheckboxChangePage();
				            })
							
							this.alarmMonitorInfo.vehicleInfo.storeParam.BranchValue = this.alarmMonitorInfo.vehicleInfo.queryParam.groupId;
							this.alarmMonitorInfo.vehicleInfo.storeParam.plateNumber = this.alarmMonitorInfo.vehicleInfo.queryParam.plateNumber;
							this.alarmMonitorInfo.vehicleInfo.storeParam.vehicleAccount = this.alarmMonitorInfo.vehicleInfo.queryParam.vehicleAccount;
							this.alarmMonitorInfo.vehicleInfo.storeParam.vehicleId = this.alarmMonitorInfo.vehicleInfo.queryParam.vehicleId;
							
							this.alarmMonitorInfo.vehicleInfo.areaTipStatis = false;
						}else{
							this.alarmMonitorInfo.vehicleInfo.areaTipStatis = true;
						}
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
					this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
					this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
					this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
				}	
			)
		},
		//清空监控车辆信息
		clearResultList() {
			this.$parent.loadingstatus.monitor = true;
			let url = '';
			let param = {};
			//新建的时候
			if (this.$parent.mode=='0'){
				url='/alarm/alarm-plans/cache';
				param = {
					almType:this.typeid,
					customerId:this.$store.state.user.groupid
				}
			}
			//编辑的时候
			if (this.$parent.mode=='1' || this.$parent.mode=='2'){
				url='/alarm/alarm-plans/' + this.$parent.planid + '/cache';
				param = {
					planId:this.$parent.planid,
					customerId:this.$store.state.user.groupid
				}
			}
			
			this.$http.delete(process.env.API_ROOT + url,{params:param})
				.then((response) => {
					if(response.body.success) {
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
					this.$parent.loadingstatus.monitor = false;
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
					this.$parent.loadingstatus.monitor = false;
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
					this.$parent.loadingstatus.monitor = false;
				}	
			)
		},
		//初始化监控车辆信息
		initResultList() {
			this.alarmMonitorInfo.monitorResultInfo.loadingstatus = true;
			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/' + this.$parent.planid + '/vehicles')
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						this.alarmMonitorInfo.alarmMonitorMode = res.isAllVeh;
						if (this.$parent.mode!=2){
							this.initModeInfo(res.isAllVeh,res.groupIds,res.panelIds);
						}
						this.getResultList(true);
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
					this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
					this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
					this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
				}	
			)
		},
		//初始化条件信息
		initModeInfo(isAllVeh,groupIds,panelIds){
			if (isAllVeh=="3"){
				var treeObj = $.fn.zTree.getZTreeObj("orgTreeBrandSelect");
				var node = treeObj.getNodes();
    			var nodes = treeObj.transformToArray(node);
				nodes.forEach( item => {
					if (groupIds.includes(item.id)){
						item.checked = true;
					}
				})
				treeObj.refresh();
				this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList = this.getCheckRootNodes();
			}else if (isAllVeh=="4"){
				var treeObj = $.fn.zTree.getZTreeObj("orgTreeBrandSelectName");
				var node = treeObj.getNodes();
    			var nodes = treeObj.transformToArray(node);
				nodes.forEach( item => {
					if (panelIds.includes(item.id)){
						item.checked = true;
					}	
				})
				treeObj.refresh();
			}
		},
		//查询监控车辆信息
		getResultList(refresh) {
			if (refresh){
				this.alarmMonitorInfo.monitorResultInfo.selAllFlg = false;
				this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel=[];
				this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel=[];
			}
			this.alarmMonitorInfo.monitorResultInfo.loadingstatus = true;
			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/temp/vehicles',{params: this.alarmMonitorInfo.monitorResultInfo.queryParam})
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						this.alarmMonitorInfo.monitorResultInfo.alarmMonitorList = res.list;
						const {pageNum,pages,total,isFirstPage,isLastPage} = res;
						this.alarmMonitorInfo.monitorResultInfo.resultPageInfo = {								
							pageNum:pageNum,
							pages:pages,		
							total: total,
							isFirstPage:isFirstPage,
							isLastPage:isLastPage
					    }
						this.$nextTick(function(){
							this.setResultCheckboxChangePage();
						})	
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
					this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
					this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
					this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
				}	
			)
		},
		//保存指定车辆信息(单独添加)
		saveMonitorListVehicleSimple(vehicleid) { 
			let url = '';
			//新建的时候
			if (this.$parent.mode=='0'){
				url='/alarm/alarm-plans/sel/vehicles/monitor-list';
			}
			//编辑的时候
			if (this.$parent.mode=='1' || this.$parent.mode=='2'){
				url='/alarm/alarm-plans/' + this.$parent.planid + '/sel/vehicles/monitor-list';
			}
			let vehList = [];
			vehList.push(vehicleid);
			let param = {
				almType:this.typeid,
				customerId:this.$store.state.user.groupid,
				groupId:'',
				isAllSel:0,
				plateNumber:'',
				vehicleAccount:'',
				vehicleId:'',
				vehList:vehList
			}
			this.alarmMonitorInfo.vehicleInfo.loadingstatus = true;
			this.$http.post(process.env.API_ROOT + url, param)
			.then( res => {
				if(res.body.success){
					this.$parent.openModalMsg(OPERATE_SUCCESS);
					this.getResultList(true);
				}else{
					this.$parent.openModalMsg(res.body.message);
				}
				this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
			}, res => {
				this.$parent.openModalMsg(res.body.message);
				this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
			}).catch( res => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
			})
		},
		//保存指定车辆信息
		saveMonitorListVehicle() { 
			let vehList = [];
			if (this.alarmMonitorInfo.vehicleInfo.selAllFlg){
				vehList = this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleCancel;
			}else{
				vehList = this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleSel;
			}
			
			if (vehList.length==0 && !this.alarmMonitorInfo.vehicleInfo.selAllFlg){
				this.$parent.openModalMsg(SELECT_VEHICLE);
				return;
			}
			
			let url = '';
			//新建的时候
			if (this.$parent.mode=='0'){
				url='/alarm/alarm-plans/sel/vehicles/monitor-list';
			}
			//编辑的时候
			if (this.$parent.mode=='1' || this.$parent.mode=='2'){
				url='/alarm/alarm-plans/' + this.$parent.planid + '/sel/vehicles/monitor-list';
			}
			let param = {
				almType:this.typeid,
				customerId:this.$store.state.user.groupid,
				groupId:this.alarmMonitorInfo.vehicleInfo.storeParam.BranchValue,
				isAllSel:this.alarmMonitorInfo.vehicleInfo.selAllFlg?1:0,
				plateNumber:this.alarmMonitorInfo.vehicleInfo.storeParam.plateNumber,
				vehicleAccount:this.alarmMonitorInfo.vehicleInfo.storeParam.vehicleAccount,
				vehicleId:this.alarmMonitorInfo.vehicleInfo.storeParam.vehicleId,
				vehList:vehList
			}
			this.alarmMonitorInfo.vehicleInfo.loadingstatus = true;
			this.$http.post(process.env.API_ROOT + url, param)
			.then( res => {
				if(res.body.success){
					this.$parent.openModalMsg(OPERATE_SUCCESS);
					this.getResultList(true);
				}else{
					this.$parent.openModalMsg(res.body.message);
				}
				this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
			}, res => {
				this.$parent.openModalMsg(res.body.message);
				this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
			}).catch( res => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.alarmMonitorInfo.vehicleInfo.loadingstatus = false;
			})
		},
		//监控车辆移出(单独移出)
		removeMonitorListSimple(vehicleid) {
			let url = '';
			let param = {};
			let vehList = [];
			vehList.push(vehicleid);
			
			//新建的时候
			if (this.$parent.mode=='0'){
				url='/alarm/alarm-plans/monitor-list';
				param = {
					almType:this.typeid,
					customerId:this.$store.state.user.groupid,
					isAllSel:this.alarmMonitorInfo.monitorResultInfo.selAllFlg?1:0,
					vehList:vehList
				}
			}
			//编辑的时候
			if (this.$parent.mode=='1' || this.$parent.mode=='2'){
				url='/alarm/alarm-plans/' + this.$parent.planid + '/monitor-list';
				param = {
					customerId:this.$store.state.user.groupid,
					isAllSel:this.alarmMonitorInfo.monitorResultInfo.selAllFlg?1:0,
					vehList:vehList
				}
			}
			this.alarmMonitorInfo.monitorResultInfo.loadingstatus = true;
			this.$http.delete(process.env.API_ROOT + url,{body:param})
			.then( res => {
				if(res.body.success){
					this.$parent.openModalMsg(OPERATE_SUCCESS);
					this.getResultList(true);
					this.setResultCheckbox();
				}else{
					this.$parent.openModalMsg(res.body.message);
				}
				this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
			}, res => {
				this.$parent.openModalMsg(res.body.message);
				this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
			}).catch( res => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
			})
			
		},
		//监控车辆移出
		removeMonitorList() {
			let url = '';
			let param = {};
			let vehList = [];
			if (this.alarmMonitorInfo.monitorResultInfo.selAllFlg){
				vehList = this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel;
			}else{
				vehList = this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel;
			}
			if (vehList.length==0 && !this.alarmMonitorInfo.monitorResultInfo.selAllFlg){
				this.$parent.openModalMsg(SELECT_VEHICLE);
				return;
			}
			//新建的时候
			if (this.$parent.mode=='0'){
				url='/alarm/alarm-plans/monitor-list';
				param = {
					almType:this.typeid,
					customerId:this.$store.state.user.groupid,
					isAllSel:this.alarmMonitorInfo.monitorResultInfo.selAllFlg?1:0,
					vehList:vehList
				}
			}
			//编辑的时候
			if (this.$parent.mode=='1' || this.$parent.mode=='2'){
				url='/alarm/alarm-plans/' + this.$parent.planid + '/monitor-list';
				param = {
					customerId:this.$store.state.user.groupid,
					isAllSel:this.alarmMonitorInfo.monitorResultInfo.selAllFlg?1:0,
					vehList:vehList
				}
			}
			this.alarmMonitorInfo.monitorResultInfo.loadingstatus = true;
			this.$http.delete(process.env.API_ROOT + url,{body:param})
			.then( res => {
				if(res.body.success){
					this.$parent.openModalMsg(OPERATE_SUCCESS);
					this.getResultList(true);
					this.setResultCheckbox();
				}else{
					this.$parent.openModalMsg(res.body.message);
				}
				this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
			}, res => {
				this.$parent.openModalMsg(res.body.message);
				this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
			}).catch( res => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.alarmMonitorInfo.monitorResultInfo.loadingstatus = false;
			})
		},
		//监控车辆隐藏查询结果
		hideMonitorResult() {
			this.alarmMonitorInfo.hiddenAppoint = false;
		},
		//换页设置复选框(车辆)
		setVehicleCheckboxChangePage(){
			let obj = document.getElementsByName('checkbox_vehicle'+this.$parent.mode);
			if (this.alarmMonitorInfo.vehicleInfo.selAllFlg){
				for(let i = 0,length=obj.length;i<length;i++){
					let val = this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicle[i].vehicleId;
					if (!this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleCancel.includes(val)){
						obj[i].checked = true;
					}else{
						obj[i].checked = false;
					}
				}
			}else{
				for(let i = 0,length=obj.length;i<length;i++){
					let val = this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicle[i].vehicleId;
					if (this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleSel.includes(val)){
						obj[i].checked = true;
					}else{
						obj[i].checked = false;
					}
				}
			}
		},
		//换页设置复选框(监控车辆)
		setResultCheckboxChangePage(){
			let obj = document.getElementsByName('checkbox_result'+this.$parent.mode); 

			if (this.alarmMonitorInfo.monitorResultInfo.selAllFlg){
				for(let i = 0,length=obj.length;i<length;i++){
					let val = this.alarmMonitorInfo.monitorResultInfo.alarmMonitorList[i].vehicleId;
					if (!this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel.includes(val)){
						obj[i].checked = true;
					}else{
						obj[i].checked = false;
					}
				}
			}else{
				for(let i = 0,length=obj.length;i<length;i++){
					let val = this.alarmMonitorInfo.monitorResultInfo.alarmMonitorList[i].vehicleId;
					if (this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel.includes(val)){
						obj[i].checked = true;
					}else{
						obj[i].checked = false;
					}
				}
			}
		},
		//全选/全取消设置复选框(车辆)
		setVehicleCheckbox(){
			let obj = document.getElementsByName('checkbox_vehicle'+this.$parent.mode);
			if (this.alarmMonitorInfo.vehicleInfo.selAllFlg){
				this.selectAllCheckbox(obj); 
				this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleCancel = [];
			}else{
				this.cancelAllCheckbox(obj); 
				this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleSel = [];
			}
		},
		//全选/全取消设置复选框(分支)
		setResultCheckbox(){
			let obj = document.getElementsByName('checkbox_result'+this.$parent.mode);
			if (this.alarmMonitorInfo.monitorResultInfo.selAllFlg){
				this.selectAllCheckbox(obj); 
				this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel = [];
			}else{
				this.cancelAllCheckbox(obj); 
				this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel = [];
			}
		},
		//指定车辆分页
		getVehiclePageNo(pageNo) { 
			this.alarmMonitorInfo.vehicleInfo.pageNo = pageNo;
			this.alarmMonitorInfo.vehicleInfo.queryParam.page_index = pageNo;
			this.getMonitorListVehicle();
		},
		//监控列表分页
		getResultPageNo(pageNo) { 
			this.alarmMonitorInfo.monitorResultInfo.pageNo = pageNo;
			this.alarmMonitorInfo.monitorResultInfo.queryParam.page_index = pageNo;
			this.getResultList(false);
		},
		//复选框全选
		selectAllCheckbox(obj){
			for(let i = 0,length=obj.length;i<length;i++){
				obj[i].checked = true;
			}
		},
		//复选框全取消
		cancelAllCheckbox(obj){
			for(let i = 0,length=obj.length;i<length;i++){
				obj[i].checked = false;
			}
		},
		//指定车辆全选
		selectAllVehicle() {
			if (this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicle.length==0){
				return;
			}
			this.alarmMonitorInfo.vehicleInfo.selAllFlg = !this.alarmMonitorInfo.vehicleInfo.selAllFlg;
			
			this.setVehicleCheckbox();
		},
		//监控车辆全选
		selectAllMonitorList() {
			if (this.alarmMonitorInfo.monitorResultInfo.alarmMonitorList.length==0){
				return;
			}
			this.alarmMonitorInfo.monitorResultInfo.selAllFlg = !this.alarmMonitorInfo.monitorResultInfo.selAllFlg;
			
			this.setResultCheckbox();
		},
		
		//指定车辆选择改变
		changeVehicleSel(val,event){
			if (this.alarmMonitorInfo.vehicleInfo.selAllFlg){
				if (event.checked){
					let index = this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleCancel.findIndex(function(value, index, arr) {
								return value == val;
					})
					this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleCancel.splice(index,1);
				}else{
					if (!this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleCancel.includes(val)){
						this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleCancel.push(val);
					}
				}
			}else{
				if (event.checked){
					if (!this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleSel.includes(val)){
						this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleSel.push(val);
					}
				}else{
					let index = this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleSel.findIndex(function(value, index, arr) {
								return value == val;
					})
					this.alarmMonitorInfo.vehicleInfo.alarmMonitorListVehicleSel.splice(index,1);
				}
			}
		},
		//监控车辆选择改变
		changeResultSel(val,event){
			if (this.alarmMonitorInfo.monitorResultInfo.selAllFlg){
				if (event.checked){
					let index = this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel.findIndex(function(value, index, arr) {
								  return value == val;
					})
					this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel.splice(index,1);
				}else{
					if (!this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel.includes(val)){
						this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListCancel.push(val);
					}
				}
			}else{
				if (event.checked){
					if (!this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel.includes(val)){
						this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel.push(val);
					}
				}else{
					let index = this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel.findIndex(function(value, index, arr) {
								return value == val;
					})
					this.alarmMonitorInfo.monitorResultInfo.alarmMonitorListSel.splice(index,1);
				}
			}
		},
		gotoCarDetail(plateNumber,id){
			if(plateNumber){
					const obj = {
						name:plateNumber,
						id:'PageCarFileDetail',
						route:'/indexhome/carFileDetail' + id,
						No:'file' + id,
						params:{id: id}
					}
					this.$router.push({path:'/indexhome/carFileDetail' + id,query:{id: id}});
					this.$store.dispatch('addTab',obj);
				}else{
					const obj = {
						name:"VE" + id,
						id:'PageCarFileDetail',
						route:'/indexhome/carFileDetail' + id,
						No:'file' + id,
						params:{id: id}
					}
					this.$router.push({path:'/indexhome/carFileDetail' + id,query:{id: id}});
					this.$store.dispatch('addTab',obj);
				}
		}
    },
    watch: {
    	alarmBaseInfo:{
    		handler(newValue, oldValue) {
　　　　　　		this.$emit('input', this.alarmMonitorInfo)
　　　　		},
			deep:true
    	},  	
		queryBranchSelectGroup(val){
    		if(val){
				let nodeList = queryTree(this.branchSelectTreeObj, val);
					//将找到的nodelist节点更新至Ztree内
				for( var i=0, l=nodeList.length; i<l; i++) {
					nodeList[i].open = false;
				}
        		$.fn.zTree.init($("#orgTreeBrandSelect"), this.settingSelect2, nodeList);
			}else{
				$.fn.zTree.init($("#orgTreeBrandSelect"), this.settingSelect,this.alarmMonitorInfo.vehicleInfo.alarmBranchList);
			}
    	},
    	queryGroup(val){
    		if(val){
    			let nodeList = queryTree(this.treeObj,val); 
    			//将找到的nodelist节点更新至Ztree内
				for( var i=0, l=nodeList.length; i<l; i++) {
					nodeList[i].open = false;
				}
    			$.fn.zTree.init($("#orgTreeBrand"), this.setting2, nodeList);
    		}else{
    			$.fn.zTree.init($("#orgTreeBrand"), this.setting, this.alarmMonitorInfo.vehicleInfo.alarmBranchList);
    		}
    	}
    }
};
</script>

<style scoped>
.menuInputBrand{
		position:relative;
	}
	.menuContent{
		position:absolute;
		top:31px;
		left:6px;
		border:1px solid #ddd;
		z-index:999;
	}
</style>



// WEBPACK FOOTER //
// AlarmPlanMonitor.vue?f2cacae4